module.exports = __webpack_public_path__ + "702c52413f7e2792346e79c91c0dd7aa.svg";